<bn-loading-overlay></bn-loading-overlay>

<h5>Tarefas para geração de relatórios</h5>

<div class="container">

  <form #formAviso="ngForm" class="form">

    <div class="container">
      <div ngbAccordion>

        <div ngbAccordionItem *ngIf="tarefaRelatoriosValorNaoComprometidoHabilitada">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Apuração do Valor Não Comprometido do Patrimônio</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn " [ngClass]="'btn-primary'"
                      (click)="abrirModalGerarRelatoriosResgatesUniao2022EmDiante()">
                      Apuração do Valor Não Comprometido do Patrimônio
                    </button>
                  </div>
                  <div class="col-6" style="display: flex; justify-content: flex-start; align-items: center;">
                    <input type="checkbox" class="form-check" id="checkGravarGeracaoRelatorios"
                      (change)="changeCheck($event)">
                    <label class="form-label" for="checkGravarGeracaoRelatorios">Gravar em tabela a geração dos
                      relatórios</label>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefasRelatoriosHabilitadas">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Apuração da Taxa Média/Máxima</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="bn-form-group">
                <div class="row" style="margin-top: 10px;">
                  <div class="col-md-4">
                    <label class="form-label" for="janela">Janela de apuração: </label>
                    <select id="janela" name="janela" class="form-select" [(ngModel)]="ideJanelaSelecionada">
                      <option [ngValue]=null></option>
                      <option [ngValue]="janela.id" *ngFor="let janela of janelasApuracaoTaxaMedia">
                        {{janela.id}} ({{janela.dataInicioJanela | date: 'dd/MM/yyyy'}} a {{janela.dataFimJanela | date:
                        'dd/MM/yyyy'}})</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
                    <select id="agenteFinanceiro" name="agenteFinanceiro" class="form-select"
                      [(ngModel)]="ideAgenteSelecionado">
                      <option [ngValue]=null>Todos</option>
                      <option [ngValue]="agente.id" *ngFor="let agente of agentesFinanceiros">{{agente.nome}}</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="apenas-simulacao"><b>Apenas simulação?</b></label>
                    <input type="checkbox" name="apenasSimulacao" class="form-check checkbox-gigante"
                      [(ngModel)]="apenasSimulacao">
                  </div>

                </div>
                </div>
                <div class="col-md-6 ">
                  <button type="button" class="btn" [ngClass]="'btn-primary'" [disabled]="!ideJanelaSelecionada"
                    (click)="gerarRelatorioTaxaMediaMaxima(ideJanelaSelecionada,apenasSimulacao,ideAgenteSelecionado)"> Executar
                    apuração da Taxa Média/Máxima
                  </button>
                </div>

                <div class="col-md-6 ">
                  <button type="button" class="btn" [ngClass]="'btn-primary'" [disabled]="!ideJanelaSelecionada"
                    (click)="reabrirJanelaApuracaoTaxaMediaMaxima(ideJanelaSelecionada)"> Reabrir janela de apuração
                  </button>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefasRelatoriosHabilitadas">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Informações de Risco - Operações a serem atualizadas</button>
          </h2>

          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row d-flex justify-content-between align-items-center">
                  <div class="col-4">
                    <div class="bn-form-group">
                      <label class="form-label" for="cnpjInfoRisco">CNPJ</label>
                      <input
                        type="text"
                        name="cnpjInfoRisco"
                        class="form-control"
                        bnMask="CNPJ"
                        [(ngModel)]="cnpjInfoRisco">
                    </div>
                  </div>
                  <div class="col-6 mt-3">
                    <button type="button" class="btn me-0 " [disabled]="!cnpjInfoRisco || undefined || cnpjInfoRisco < 18" [ngClass]="'btn-primary'"
                      (click)="atualizarBaseOperacoesInformacaoRisco()"> Atualizar base de dados com as Informações de Risco
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefasRelatoriosHabilitadas">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Relatório de saldo garantido - Crédito Livre</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn " [ngClass]="'btn-primary'"
                      (click)="gerarRelatorioSaldoGarantidoCreditoLivre()"> Emitir relatório saldo garantido - Crédito Livre
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefasRelatoriosHabilitadas">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Relatório de saldo garantido - Repasse</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn " [ngClass]="'btn-primary'"
                      (click)="gerarRelatorioSaldoGarantidoRepasse()"> Emitir relatório saldo garantido - Repasse
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefasRelatoriosHabilitadas">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Relatório de confronto contábil - Crédito Livre</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn " [ngClass]="'btn-primary'"
                      (click)="gerarRelatorioConfrontoContabilCreditoLivre()"> Emitir relatório confronto contábil - Crédito
                      Livre
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefasRelatoriosHabilitadas">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Relatório de confronto contábil - Repasse</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn " [ngClass]="'btn-primary'"
                      (click)="gerarRelatorioConfrontoContabilRepasse()"> Emitir relatório confronto contábil - Repasse
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefaRelatoriosExposicaoLimiteHabilitada">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Relatório de limite de exposição</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn " [ngClass]="'btn-primary'"
                      (click)="gerarRelatorioLimiteExposicao()"> Emitir relatório de limite de exposição
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefasRelatoriosHabilitadas">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Relatório de Apuração da PENG - Crédito Livre</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn " [ngClass]="'btn-primary'"
                      (click)="gerarRelatorioPengCreditoLivre()"> Emitir relatório apuração da PENG - Crédito Livre
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div ngbAccordionItem *ngIf="tarefasRelatoriosHabilitadas">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Relatório de Apuração da PENG - Repasse</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn " [ngClass]="'btn-primary'"
                      (click)="gerarRelatorioPengRepasse()"> Emitir relatório apuração da PENG - Repasse
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

      </div>
    </div>

  </form>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0" == true>
  <div class="row">
    <div class="table-responsive col-auto">
      <table class="table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-center">Erro(s) encontrado(s)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ocorrencia of ocorrencias">
            <td>{{ ocorrencia.mensagem }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #mensagemGravarGeracaoRelatorioValorNaoComprometido>
  <div class="row">
    <div class="bn-form-group col-12">
      Esta ação irá realizar a geração do relatório sem armazenar os dados em tabela.
    </div>
  </div>
  <div class="row">
    <div class="col-12">
     Você confirma?
    </div>
  </div>
</ng-template>
<ng-template #botoesGravarGeracaoRelatorioValorNaoComprometido>
  <button class="btn btn-success" (click)="gerarRelatoriosResgatesUniao2022EmDiante()">Sim</button>
  <button class="btn btn-danger" (click)="cancelarModal()">Não</button>
</ng-template>
